module.exports = __webpack_public_path__ + "img/pozzo-NB.137ed76a.gif";